// IPv4 address, same check as the app
export const IPV4_REGEX = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

// The app only lets digits and dots be typed in an IP address
export function filterIpInput(value) {
    return value.replace(/[^0-9.]/g, '');
}
